// eslint-disable-next-line no-restricted-imports
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { logRequestAndResponseDetails } from '../interceptors/logRequestAndResponseDetails';
import { preventRealRequestsInTests } from '../interceptors/preventRealRequestsInTests';

export type ClientOptions = {
  config: AxiosRequestConfig;
  interceptors?: Array<(client: AxiosInstance) => void>;
};

export const createHttpClient = (options: ClientOptions) => {
  const client = axios.create({
    ...options.config,
    headers: {
      'Content-Type': 'application/json',
      ...options.config.headers
    }
  });
  [
    ...(options.interceptors || []),
    // Always apply these interceptors last
    preventRealRequestsInTests,
    logRequestAndResponseDetails
  ].forEach(interceptor => interceptor(client));
  return client;
};
